export function filtersReset() {
    const formFilters = $('.form-filters');
    const form = formFilters.find('form');
    const selects = form.find('select');
    const resetBtn = formFilters.find('.reset');
    resetBtn.on('click', function (e) {
        e.preventDefault();

        form.find('input:text, textarea').val('');
        selects.each(function () {
            $(this).prop("selectedIndex", 0);
            jcf.replaceAll();
        })
    })
}


// WEBPACK FOOTER //
// ./assets/js/modules/filtersReset.js